/**
 * @fileoverview Formatação dos dados das OS para a tela (datas do fabricante,
 * telefone, CPF/CNPJ, CEP e endereço). As datas do fabricante vêm no horário
 * local dele ("AAAA-MM-DD HH:mm:ss") e são mostradas como vieram, sem fuso.
 */

export const EMPTY = "—";

/** "2026-09-27 09:05:00" → "27/09/2026 09:05"; "2026-01-15" → "15/01/2026". */
export const formatOriginDate = (value) => {
  if (typeof value !== "string") return EMPTY;
  const m = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
  if (!m) return value || EMPTY;
  const [, y, mo, d, h, mi] = m;
  return h ? `${d}/${mo}/${y} ${h}:${mi}` : `${d}/${mo}/${y}`;
};

/** Datas do Sttelar (ISO, UTC) no horário de quem está vendo. */
export const formatLocalDateTime = (value) => {
  if (!value) return EMPTY;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return EMPTY;
  return d.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
};

export const formatPhone = (digits) => {
  const d = String(digits || "");
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return d || EMPTY;
};

export const formatDocument = (digits) => {
  const d = String(digits || "");
  if (d.length === 11) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
  if (d.length === 14) {
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
  }
  return d || EMPTY;
};

export const formatZip = (digits) => {
  const d = String(digits || "");
  return d.length === 8 ? `${d.slice(0, 5)}-${d.slice(5)}` : d || EMPTY;
};

/** Endereço montado dos campos separados; sem eles, o texto completo da origem. */
export const formatAddress = (address) => {
  if (!address) return EMPTY;
  const street = [address.street, address.number].filter(Boolean).join(", ");
  const cityState = [address.city, address.state].filter(Boolean).join("/");
  const parts = [street, address.district, cityState, address.zip && `CEP ${formatZip(address.zip)}`].filter(Boolean);
  return parts.length ? parts.join(" · ") : address.full || EMPTY;
};
